import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

import { type FetchTasksFilters } from '../../../api/tasksBoardTypes';

export const selectBoardTasksFilters = createSelector(
  (state: RootState) => state.tasksBoard.filters,
  (filters): FetchTasksFilters => {
    const query: FetchTasksFilters = {};

    const { quick, header } = filters;

    /* header */
    if (header.team?.id) query.teamId = header.team.id;
    if (header.creator?.id) query.authorId = header.creator.id;
    if (header.assignee?.id) query.assigneeId = header.assignee.id;
    if (header.creatorRole) query.authorRole = header.creatorRole;
    if (header.search) query.search = header.search;
    if (header.expiredOnly) query.expired = true;
    if (header.range) query.range = header.range;
    if (header.rangeBy && header.range) query.rangeBy = header.rangeBy;
    if (header.category) query.category = header.category;

    /* quick */
    switch (quick.ownership) {
      case 'MY':
        query.ownership = true;
        break;

      case 'ASSIGNED':
        query.assigned = true;
        break;

      case 'NEW':
        query.isNew = true;
        break;
    }
    if (quick.priority) query.priority = quick.priority;
    if (quick.expired) query.expired = true;
    if (quick.golden) query.isGold = true;

    return query;
  }
);
